import { Card, CardBody, Col, FormGroup, Label, Row } from 'reactstrap';
import { UploadProjectFiles } from '../../../utils/Constant';
import { Dropzone, FileMosaic, ExtFile } from "@dropzone-ui/react";
import { H5, H6, P, SVG } from '../../../AbstractElements';
import { useEffect, useState } from 'react';
import { isImageFile, isVideoFile } from '../../../utils';
import { PageFile } from './ReportCreator';

interface UploadFileProps {
  pageFiles: PageFile[];
  setPageFiles: (files: PageFile[]) => void;
  pageFile: PageFile;
  setPageFile: (file: PageFile) => void;
  elementFileId: string;
  filetype: string;
}

const MAX_FILE_SIZE = 1 * 1024 * 1024; // 1MB in bytes

const UploadFile: React.FC<UploadFileProps> = ({ pageFiles, setPageFiles, filetype, elementFileId, pageFile, setPageFile }) => {
  const [files, setFiles] = useState<any[]>([]);
  const [fileError, setFileError] = useState<string | null>(null);
  const [isUploaded, setIsUploaded] = useState(false);
  
  useEffect(() => {
    if (elementFileId) {
      const _v = pageFiles.find(v => v?.id === elementFileId)
      setFiles([_v?.file])
    }
    else {
      setFiles([])
    }
  }, [elementFileId])

  const updateFiles = (incomingFiles: ExtFile[]) => {
    const validFiles = incomingFiles.filter((file) => {
      if (file.file && file.file.size <= MAX_FILE_SIZE) {
        return true;
      } else {
        setFileError("File size must be less than 1MB");
        return false;
      }
    });

    if (validFiles.length > 0) {
      setFiles(validFiles);
      const _file: PageFile = {
        file: validFiles.length > 0 && validFiles[0].file !== undefined ? { file: validFiles[0].file , name: validFiles[0].name, type: validFiles[0].type, valid: true } : null,
        id: Date.now().toString(36)
      }
      setPageFile(_file)
      // setVideoFiles([...videoFiles, _videoFile]);
      setIsUploaded(true);
      setFileError(null);
    } else {
      setFiles([]);
      setIsUploaded(false);
    }
  };

  const removeFile = (id: string | number | undefined) => {
    const _files = files.filter((x: ExtFile) => x.id !== id)
    setFiles(_files);
    setPageFile({ id: "", file: null });
    setIsUploaded(false);
    setFileError(null);
  };

  return (
    <Row className='element-property-video'>
      <Col>
        <FormGroup>
          <Label check>{`Upload ${filetype} file`}</Label>
          <Dropzone onChange={updateFiles} value={files} maxFiles={1} accept={filetype === 'video' ? "video/mp4": 'image/*'} header={false} footer={false} minHeight="80px" label="Drag'n drop files here or click to Browse">
            {files.map((file: ExtFile, key) => (
              <FileMosaic key={"file" + key} {...file} onDelete={removeFile} info={true} />
            ))}
            {files.length === 0 && (
              <div className="dz-message needsclick p-5">
                <SVG iconId="file-upload" />
                <P>
                  Drag your {filetype} file here, or
                  <span className="txt-primary ms-2">
                    Browse
                  </span>
                </P>
              </div>
            )}
          </Dropzone>
          {fileError && <P className='text-danger'>{fileError}</P>}
          {isUploaded &&
            files.length > 0 && 
            (filetype==='video' && !isVideoFile(files.length > 0 && files[0].file !== undefined ? files[0].file : null) ||
            filetype==='image' && !isImageFile(files.length > 0 && files[0].file !== undefined ? files[0].file : null)
          ) ?
            <P className='text-danger'>You must upload an image filetype</P> :
            ""}
        </FormGroup>
      </Col>
    </Row>
  );
}

export default UploadFile;
